/**
* Nom : LedCardList.js
* Description : Ce fichier contient la définition de la page LedCardList 
*               Cette page affiche les éléments pour gérer les cartes Led
*               Le terme 'equipment' dans le code correspond à un produit client
* Date de création : 19 mars 2026
*/

/* CSS et assets */
import { AddIcon } from 'package_ui_ihm/dist'

/* Bibliothèques et composants */
import { CompanyBar } from 'package_ui_ihm/dist'
import { TabC } from 'package_ui_ihm/dist'
import { Container } from 'package_ui_ihm/dist'
import { Item } from 'package_ui_ihm/dist'
import { BackPage } from 'package_ui_ihm/dist'
import { GotoPage } from 'package_ui_ihm/dist'
//import { SelectFormSide } from 'package_ui_ihm/dist'
import { SelectFormSide } from 'package_ui_ihm/dist'
import { InputFormSide } from 'package_ui_ihm/dist'
import Divider from '@mui/material/Divider';

/* Hook */
import { useState, useEffect } from 'react'
import { useBlocker } from 'react-router-dom'
import { useAuth } from 'package_ui_ihm/dist'
import { useApi } from 'package_ui_ihm/dist'
import { useScreenWidth } from 'package_ui_ihm/dist'


/**
* LedCardList : affiche la page qui contient les éléments pour gérer les cartes LEDs
*               un formulaire permet de filtrer en fonction du type de carte led 
*               pour afficher la liste de tout les types de carte LEDs associés
*               un lien permet d'afficher un formulaire pour créer une nouvelle carte LEDs
*               un lien permet de revenir sur la page qui liste tous les sous-ensemble
*               un lien permet d'aller sur la page qui liste tous les types de PTUs
*               un lien permet d'aller sur la page qui liste tous les types de carte LEDs
*               un lien permet d'aller sur la page qui liste tous les types de LEDs
*
* Type : page 
*
* Parametres : 
*  None
*/
function LedCardList() {

    // Define useState hooks
    const [serialNumber, setSerialNumber] = useState('');
    const [serialNumberError, setSerialNumberError] = useState(false);
    const [ledCardTypes, setLedCardTypes] = useState([])
    const [selectedLedCardType, setSelectedLedCardType] = useState(0)
    const [ledCardTypeError, setLedCardTypeError] = useState(false);
    const [ptus, setPtus] = useState([])
    const [isDataLoading, setDataLoading] = useState(false)
    const [isCreation, setCreation] = useState(false)
    const [ledCards, setLedCards] = useState([])
    const [statusLedCards, setStatusLedCards] = useState(null)
    const [baseSN, setBaseSN] = useState(null)
    const [formSubmit, setFormSubmit] = useState(false);


    // Define useContext hooks
    const { authStatus, authToken, currentUser } = useAuth();
    const { path } = useApi();


    // Define useBlocker hooks
    const shouldBlock = isCreation;
    const blocker = useBlocker(shouldBlock);


    // Define useScreenWidth hooks
    const screenWidth = useScreenWidth();


    // Define functions
    async function sendData(serial_number, led_card_type_id) {
        // Token
        const token = "Bearer " + authToken
        // Création du Form Data
        let form_data = new FormData();
        form_data.append("serial_number", serial_number);
        form_data.append("led_card_type_id", led_card_type_id);
        // Create ledCard
        const response = await fetch(path + "/api/eq-leca/", 
            {
                method: 'POST',
                credentials: 'include',
                mode: 'cors',
                headers: {
                    accept: 'application/json',
                    //'Content-Type': 'multipart/form-data',  cette ligne ne doit pas être utilisée avec FormData sinon erreur
                    Authorization: token,
                },
                body: form_data
            }
        )
        setStatusLedCards(response["status"])
        if(response["status"] === 201){
            // Reset du formulaire
            setCreation(false)
            setSerialNumber(baseSN)
            // Update ptuType list
            retrieveLedCards()
        }
        setFormSubmit(false)
    }

    const handleClick = (event) => {
        event.preventDefault();
        setCreation(true)
    };

    const handleSubmit = (event) => {
        event.preventDefault();
        // Check of data for PTU type
        if(serialNumber === baseSN){
            setSerialNumberError(true)
        }
        else
        {   
            setSerialNumberError(false)
        }
        if(selectedLedCardType === 0 || selectedLedCardType === '0'){
            setLedCardTypeError(true)
        }
        else
        {   
            setLedCardTypeError(false)
        }
        setFormSubmit(true)
    };

    const handleReset = (event) => {
        event.preventDefault();
        setCreation(false)
        setSerialNumber(baseSN)
        setSerialNumberError(false)
    };

    async function retrieveData() {
        // Token
        const token = "Bearer " + authToken
        // Headers
        const headers = {
            accept: 'application/json',
            Authorization: token,
        }
        // Requests in parallel to win time 
        const [resLedCardType, resPtu] = await Promise.all([
            // led_card_type
            fetch(path + "/api/eq-lcty/", {
                method: 'GET',
                credentials: 'include',
                mode: 'cors',
                headers,
            }),
            // ptus
            fetch(path + "/api/eq-mole/", {
                method: 'GET',
                credentials: 'include',
                mode: 'cors',
                headers,
            }),
        ])
        // Responses in parallel to win time
        const [dataLedCardType, dataPtu] = await Promise.all([
            resLedCardType.json(),
            resPtu.json(),
        ])
        // Set variables
        setLedCardTypes(dataLedCardType["results"])
        setPtus(dataPtu["results"])
        // Dataloading
        setDataLoading(false)
    }

    async function retrieveLedCards() {
        // Token
        const token = "Bearer " + authToken
        // Retrieve led_card
        const resLedCard= await fetch(path + "/api/eq-leca/?led_card_type_id=" + selectedLedCardType, 
            {
                method: 'GET',
                credentials: 'include',
                mode: 'cors',
                headers: {
                    accept: 'application/json',
                    Authorization: token,
                },
            }
        );
        const dataLedCard = await resLedCard.json();
        setLedCards(dataLedCard["results"])
    }

    const retrievePtuSN = (id) => {
        return ptus.find((ptu) => Number(ptu['id']) === Number(id))
    };

    function retrieve_reference_object_from_id(list, id) {
        return (list.find((item) => (item['id'] === Number(id))))['reference_AT']
    }
    

    // Define useEffect hooks
    useEffect(() => {
        if(authStatus === 200)
        {
            setDataLoading(true)
            retrieveData()
        }
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [])

    useEffect(() => {
        if(selectedLedCardType > 0)
        {
            let base_sn = 'SN-' + retrieve_reference_object_from_id(ledCardTypes, selectedLedCardType) + '-'
            setBaseSN(base_sn)
            setSerialNumber(base_sn)
        }
        retrieveLedCards()
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [selectedLedCardType]);

    useEffect(() => {
        if(formSubmit === true && serialNumberError === false && ledCardTypeError === false){
            sendData(serialNumber, selectedLedCardType)
        } else {
            setFormSubmit(false)
        }
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [formSubmit]);

    useEffect(() => {
        // Bloquer la fermeture d'onglet/rafraîchissement
        const handleBeforeUnload = (e) => {
        if (shouldBlock === true) {
            // Standard pour afficher une confirmation (les navigateurs modernes gèrent le message)
            e.preventDefault();
            e.returnValue = "";
            // Certains navigateurs nécessitent cette ligne pour afficher la confirmation
            return (e.returnValue = "Cette page vous demande de confirmer sa fermeture ; des données que vous avez saisies pourraient ne pas être enregistrées.");
        }
        }; 

        window.addEventListener("beforeunload", handleBeforeUnload);

        // Nettoyer l'écouteur quand le composant est démonté
        return () => {
        window.removeEventListener("beforeunload", handleBeforeUnload);
        };
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [shouldBlock]);

    useEffect(() => {
        if (blocker.state === "blocked") {
            const confirmed = window.confirm(
                "Cette page vous demande de confirmer sa fermeture ; des données que vous avez saisies pourraient ne pas être enregistrées."
            );

            if (confirmed) {
                blocker.proceed();
            } else {
                blocker.reset();
            }
        }
    }, [blocker]);


    // Render component
    return (
        <div>
            <CompanyBar name_app="BOXIBRAIN"/>
            <TabC tabNumber={1}/>
            <div className={(screenWidth > 650) ? 'App' : 'App-ss'}>
                <Container>
                    {isDataLoading ? (
                        <p>Chargement des données</p>
                    ) : (
                        <div>
                            <h1>Cartes LEDs</h1>
                            {/*Lien de retour*/}
                            <div className={(screenWidth > 650) ? 'flex-row justify-center margin-bottom margin-top' : 'grid-1-1 justify-center margin-bottom margin-top'}>
                                <div className='link-border' style={(screenWidth > 650) ? { width: 240 } : null}>
                                    <BackPage path={'/equipments/subset'}>Retour aux sous-ensembles</BackPage>
                                </div>
                                <div className='link-border' style={(screenWidth > 650) ? { width: 240 } : null}>
                                    <GotoPage path={'/equipments/ptuType'}>Types de PTUs</GotoPage>
                                </div>
                                <div className='link-border' style={(screenWidth > 650) ? { width: 240 } : null}>
                                    <GotoPage path={'/equipments/ledCardType'}>Types de Cartes LED</GotoPage>
                                </div>
                                <div className='link-border' style={(screenWidth > 650) ? { width: 240 } : null}>
                                    <GotoPage path={'/equipments/ledType'}>Types de LEDs</GotoPage>
                                </div>
                            </div>
                            {/*Choix du type de carte LED*/}
                                <form className='grid-1-1-1'>
                                    {/*<h3>Choisir le type de carte LED</h3>*/}
                                    <div/>
                                    <SelectFormSide error={ledCardTypeError} labelText='Choisir le type de carte LED' choices={ledCardTypes.sort((a, b) => (a.reference_AT > b.reference_AT)?1:-1)} choiceParam={'reference_AT'} selectedItem={selectedLedCardType} setSelectedItem={setSelectedLedCardType}/>
                                </form>
                            {/*Message d'erreur*/}
                            {(statusLedCards !== null && statusLedCards !== 201 && serialNumberError === false && ledCardTypeError === false) ? (
                                <p className='form-error'>La carte LED existe déjà ou n'a pas pu être enregistré !</p>
                            ) : (
                                <p/>
                            )} 
                            {/*Liste et formulaire*/}
                            <div className={(screenWidth > 650) ? 'grid-1-3' : null}>
                                <div>
                                    {(selectedLedCardType > 0) ? (
                                        /*New*/
                                        (currentUser["role_name"] !== "AT_RESEARCH") ? (
                                            <div className='flex-column'>
                                                <div className='link' onClick={handleClick}>
                                                    <img src={AddIcon} alt='add_item_icon' className='link-img' />
                                                    <div className='link-text'>Carte LED</div>
                                                </div>
                                                {(isCreation === true) ? (
                                                    <div className='flex-rows'>
                                                        <h3>Nouvelle carte LED</h3>
                                                        <form onSubmit={handleSubmit} onReset={handleReset} className='flex-column'>
                                                            <div className='flex-column'>
                                                                <InputFormSide error={serialNumberError} type="text" label="Serial number" value={serialNumber} setValue={setSerialNumber}/>
                                                                <p className='italic-text-note margin-bottom'>Serial number = SN-référence_carte_LED-' + 4 chiffres</p>
                                                            </div>
                                                            <div className='flex-row form-center'>
                                                                <button type="reset" className='button'>Annuler</button>
                                                                <button type="submit" className='button'>Valider</button>
                                                            </div>
                                                        </form> 
                                                    </div>
                                                ) : (
                                                    <div></div>
                                                )}
                                            </div>
                                        ) : (
                                            null
                                        )
                                    ) : (
                                        <div/>
                                    )}
                                </div>
                                {(screenWidth > 650) ? null : <Divider/>}
                                {/*PTU list list*/}
                                <div className='scroll-list-rd'>
                                    {(selectedLedCardType > 0) ? (
                                        (ledCards && ledCards.length !== 0) ? (
                                            ledCards.sort((a, b) => (a.serial_number > b.serial_number)?1:-1).map((ledCard) => (
                                                <Item key={ledCard['id']} id={ledCard['id']}>
                                                    <h3 className='item-text'>Serial number: {ledCard['serial_number']}</h3> 
                                                    {ledCard['module_id'] ? (
                                                        <p className='item-text'>PTU associé {retrievePtuSN(ledCard['module_id'])['serial_number']}</p>
                                                    ) : (
                                                        <p className='item-text'>Non attribué à un PTU</p>
                                                    )}
                                                </Item>
                                            ))
                                        ) : (
                                            <p>Aucune carte LED actuellement. Veuillez en créer une !</p>
                                        )
                                    ) : (
                                        <p>Aucun type de carte LED selectionné actuellement.</p>
                                    )}
                                </div>
                            </div>
                        </div>
                    )}
                </Container>
            </div>
        </div>
    );
}

export default LedCardList;
